export default __webpack_public_path__ + "adobe-spark.0a1ab9d8.png";